export default __webpack_public_path__ + "static/marketIntegrationMobile2-abd27ed1bf9ee59fe7b34cb561073100.jpg";